export class ChartPHB2BB2CPData {
  public constructor (
    readonly year: string,
    readonly privateAddress: string,
    readonly sum: string,
  ) {}

  static createListFromResponse (data: any): Array<ChartPHB2BB2CPData> {
    return data.map((item: any) => {
      return new ChartPHB2BB2CPData(
        item.Jahr,
        item.Privatadresse,
        item.Stunden_Prozent
      )
    })
  }
}